import { render, staticRenderFns } from "./Surveys.vue?vue&type=template&id=58c7193c&scoped=true"
import script from "./Surveys.vue?vue&type=script&lang=js"
export * from "./Surveys.vue?vue&type=script&lang=js"
import style0 from "./Surveys.vue?vue&type=style&index=0&id=58c7193c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c7193c",
  null
  
)

export default component.exports